import { Trans } from 'react-i18next';

import { ModalConfirmExitConfig } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';

const t =
   patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.documentTemplateModal.confirmationModal;

export const modalConfirmingExitConfig = (enabled: boolean): ModalConfirmExitConfig => ({
   enabled: enabled,
   content: <Trans i18nKey={t.description} components={{ bold: <strong /> }} />,
   confirmationButtonLabel: t.actions.confirm,
});
